(() => {
  // NOTE: do NOT keep a permanent reference to #haut-builder because the theme may rerender it.
  const getUI = () => document.getElementById("haut-builder");

  // If the builder isn't on the page, do nothing.
  if (!getUI()) return;

  const STEP = Number(getUI()?.dataset?.step || 5);
  const log = (...args) => console.log("[HAUT]", ...args);

  // Variants JSON injected in your builder snippet (should be stable)
  const variantsJsonEl = document.getElementById("haut-variants-json");
  const variants = variantsJsonEl ? JSON.parse(variantsJsonEl.textContent) : [];

  const extractNumber = (str) => {
    const m = String(str).match(/\d+/);
    return m ? Number(m[0]) : 0;
  };

  // Persist counts across rerenders
  const STORAGE_KEY = `haut_builder_${location.pathname}`;

  const loadPersisted = () => {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  };

  const savePersisted = (counts) => {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ counts }));
    } catch {}
  };

  const persisted = loadPersisted();

  const state = {
    target: 0,
    userTouched: false,
    counts: {
      Pomme: persisted?.counts?.Pomme ?? 0,
      Poire: persisted?.counts?.Poire ?? 0,
      Nature: persisted?.counts?.Nature ?? 0,
    },
  };

  const sum = () => Object.values(state.counts).reduce((a, b) => a + b, 0);

  // Form nodes (theme may swap)
  let form = null;
  let idInput = null;
  let addBtn = null;

  // Variant detection
  let lastVariantId = "";
  let variantPollTimer = null;

  // Prevent bind loops
  let didInit = false;
  let bindCooldownTimer = null;

  const findCurrentForm = () => {
    const ui = getUI();
    const productRoot = ui?.closest(".product") || document;
    return productRoot.querySelector("form[action*='/cart/add']");
  };

  const refreshFormRefs = () => {
    if (!form) return;
    idInput = form.querySelector('input[name="id"]');
    addBtn =
      form.querySelector('button[type="submit"][name="add"]') ||
      form.querySelector('button[type="submit"]');
  };

  const getVariantId = () => (idInput ? String(idInput.value || "") : "");

  const getBoxSizeFromVariantId = () => {
    const variantId = idInput ? Number(idInput.value) : 0;
    if (!variantId || !variants.length) return 0;

    const v = variants.find((x) => Number(x.id) === variantId);
    if (!v) return 0;

    return extractNumber(v.option1); // "20 barres" -> 20
  };

  const syncHiddenProps = () => {
  // Update props in ALL add-to-cart forms (main + quick-buy + anything else)
  document.querySelectorAll('form[action*="/cart/add"]').forEach((f) => {
    const propPomme  = f.querySelector('input[name="properties[Pomme]"]');
    const propPoire  = f.querySelector('input[name="properties[Poire]"]');
    const propNature = f.querySelector('input[name="properties[Nature]"]');
    const propBoite  = f.querySelector('input[name="properties[Boite]"]');

    if (propPomme)  propPomme.value  = String(state.counts.Pomme);
    if (propPoire)  propPoire.value  = String(state.counts.Poire);
    if (propNature) propNature.value = String(state.counts.Nature);
    if (propBoite)  propBoite.value  = state.target ? String(state.target) : "";
  });
};

  const setError = (msg) => {
    const ui = getUI();
    if (!ui) return;

    const errEl = ui.querySelector("#haut-error");
    if (!errEl) return;

    if (!msg) {
      errEl.style.display = "none";
      errEl.textContent = "";
    } else {
      errEl.style.display = "block";
      errEl.textContent = msg;
    }
  };

  const syncQtyUI = () => {
    const ui = getUI();
    if (!ui) return;

    ui.querySelectorAll(".haut-row").forEach((r) => {
      const flavour = r.dataset.flavour;
      const qtyEl = r.querySelector(".haut-qty");
      if (qtyEl) qtyEl.textContent = String(state.counts[flavour] ?? 0);
    });
  };

  const updatePlusMinusDisabled = () => {
    const ui = getUI();
    if (!ui) return;

    const total = sum();

    ui.querySelectorAll(".haut-row").forEach((r) => {
      const flavour = r.dataset.flavour;
      const plus = r.querySelector(".haut-plus");
      const minus = r.querySelector(".haut-minus");

      if (plus) plus.disabled = state.target === 0 || total + STEP > state.target;
      if (minus) minus.disabled = (state.counts[flavour] ?? 0) <= 0;
    });
  };

  const render = () => {
    const ui = getUI();
    if (!ui) return;

    const total = sum();

    const totalEl = ui.querySelector("#haut-total");
    const targetEl = ui.querySelector("#haut-target");
    const msgEl = ui.querySelector("#haut-msg");

    if (totalEl) totalEl.textContent = String(total);
    if (targetEl) targetEl.textContent = String(state.target || 0);

    const ok = state.target > 0 && total === state.target;
    if (addBtn) addBtn.disabled = !ok;

    if (state.target === 0) {
      setError("Choisis d’abord la taille de votre ravitaillement (10/20/40).");
      if (msgEl) msgEl.textContent = "Choisissez vos barres par lots de 5.";
    } else if (total < state.target) {
      setError(`Il vous reste ${state.target - total} barres à choisir.`);
      if (msgEl) msgEl.textContent = "Ajoute par lots de 5.";
    } else if (total > state.target) {
      setError(`Vous avez ${total - state.target} barres en trop.`);
    } else {
      setError("");
      if (msgEl) msgEl.textContent = "Parfait. Votre ravitaillement est prêt!";
    }

    updatePlusMinusDisabled();
    savePersisted(state.counts);
    syncHiddenProps();
  };

  const bump = (flavour, dir) => {
    state.userTouched = true;
    if (!state.target) return;

    const current = state.counts[flavour] ?? 0;
    const next = current + dir * STEP;
    if (next < 0) return;

    if (dir > 0 && sum() + STEP > state.target) return;

    state.counts[flavour] = next;

    const ui = getUI();
    const row = ui?.querySelector(`.haut-row[data-flavour="${CSS.escape(flavour)}"]`);
    const qtyEl = row?.querySelector(".haut-qty");
    if (qtyEl) qtyEl.textContent = String(next);

    render();
  };

  // Auto presets that follow the selected box size UNTIL the user clicks +/-
  const applyPresetForTarget = () => {
    if (state.userTouched) return;
    if (!state.target) return;

    const presets = {
      10: { Pomme: 5,  Poire: 0,  Nature: 5 },
      20: { Pomme: 5, Poire: 5,  Nature: 10 },
      40: { Pomme: 10, Poire: 10, Nature: 20 },
      60: { Pomme: 20, Poire: 20, Nature: 20 },
    };

    const preset = presets[state.target];
    if (!preset) return;

    state.counts.Pomme = preset.Pomme;
    state.counts.Poire = preset.Poire;
    state.counts.Nature = preset.Nature;

    // IMPORTANT: persist immediately so rerenders/polls don't "snap back"
    savePersisted(state.counts);

    syncQtyUI();
    render();
  };

  const onVariantChange = (reason = "unknown") => {
  refreshFormRefs();

  const target = getBoxSizeFromVariantId();
  state.target = target;

  // Reset the mix every time the user selects a new variant
  state.userTouched = false;
  applyPresetForTarget();

  const vid = getVariantId();
  log("onVariantChange", { reason, variantId: vid, target });

  syncQtyUI();
  render();
};

  const startVariantPolling = () => {
    if (variantPollTimer) clearInterval(variantPollTimer);

    lastVariantId = getVariantId();

    variantPollTimer = setInterval(() => {
      // if form got replaced, rebind
      if (!form || !document.contains(form)) {
        bindForm(true);
      }

      const current = getVariantId();
      if (current && current !== lastVariantId) {
        lastVariantId = current;
        onVariantChange("poll");
      }
    }, 150);
  };

  const bindForm = (force = false) => {
    const newForm = findCurrentForm();
    if (!newForm) return;

    const swapped = newForm !== form;
    if (!force && !swapped && didInit) {
      form = newForm;
      refreshFormRefs();
      return;
    }

    form = newForm;
    refreshFormRefs();

    if (!form.dataset.hautSubmitBound) {
      form.addEventListener("submit", (e) => {
        const ok = state.target > 0 && sum() === state.target;
        if (!ok) {
          e.preventDefault();
          render();
        }
      });
      form.dataset.hautSubmitBound = "1";
    }

    if (!form.dataset.hautVariantChangeBound) {
      form.addEventListener("change", (e) => {
        const n = String(e.target?.name || "");
        if (n.startsWith("options[") || n.startsWith("option")) {
          setTimeout(() => onVariantChange("change"), 0);
        }
      });
      form.dataset.hautVariantChangeBound = "1";
    }

    startVariantPolling();

    if (!didInit || swapped || force) {
      didInit = true;
      lastVariantId = getVariantId();
      onVariantChange(swapped ? "form swapped" : force ? "forced rebind" : "init");
    }
  };

  // +/- event delegation (document-level; survives builder swaps)
  document.addEventListener("click", (e) => {
    const plusBtn = e.target.closest(".haut-plus");
    const minusBtn = e.target.closest(".haut-minus");
    if (!plusBtn && !minusBtn) return;

    const row = e.target.closest(".haut-row");
    const flavour = row?.dataset?.flavour;
    if (!flavour) return;

    const currentBuilder = getUI();
    if (!currentBuilder || !currentBuilder.contains(row)) return;

    if (plusBtn) bump(flavour, +1);
    if (minusBtn) bump(flavour, -1);
  });

  // Observe form swaps, debounced
  const getRerenderRoot = () =>
    getUI()?.closest("product-rerender") ||
    getUI()?.closest(".product") ||
    document.body;

  const scheduleBind = () => {
    if (bindCooldownTimer) return;
    bindCooldownTimer = setTimeout(() => {
      bindCooldownTimer = null;
      bindForm(false);
      syncQtyUI();
      render();
    }, 300);
  };

  const formObs = new MutationObserver(scheduleBind);
  formObs.observe(getRerenderRoot(), { childList: true, subtree: true });

  document.addEventListener("variant:change", () => onVariantChange("variant:change"));
  document.addEventListener("product:variant-change", () => onVariantChange("product:variant-change"));

  // Debug API
  window.HAUT_BUILDER = {
    refresh: () => {
      bindForm(true);
      onVariantChange("manual refresh");
      return true;
    },
    state: () => ({
      target: state.target,
      userTouched: state.userTouched,
      counts: { ...state.counts },
      total: sum(),
      variantId: getVariantId(),
    }),
    form: () => ({
      hasForm: !!form,
      inDom: form ? document.contains(form) : false,
      variantId: getVariantId(),
    }),
    resetTouched: () => {
      state.userTouched = false;
      applyPresetForTarget();
      return true;
    },
  };

  log("box builder loaded");
  bindForm(true);
  syncQtyUI();
  render();
})();
